/* eslint-disable no-case-declarations */
/* eslint-disable @typescript-eslint/no-explicit-any */

import { FC, useState, useEffect, useRef } from "react";
import { useStores } from "@/app/csr-src/models";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";


import { validateAppleMerchant, redirectPayResult } from "@/app/csr-src/apis/checkout/checkout.api";

import { Button } from "@mui/material";

import UKToast from "@/common-components-src/components/UKToast/index";;
import ApplePaySvg from "@/assets/icons/pay/ApplePay.svg";

import Styles from "../payButton/btn.module.scss";
import { PAY_STATUS, PAY_TYPE } from "@/app/csr-src/apis/checkout/constants/constants";

let paymentsSession: any = null;
let timer = null;
let count = 0;
interface ApplePayProps {
  onSubmit: () => any; // 提单
  onFinish: (res: any) => void; // 支付完成后的回调
  onLoadingResult: (data: any, errorCb: () => void) => any; // 支付loading
}

const ApplePay: FC<ApplePayProps> = observer((props) => {
  const { t } = useTranslation();
  const { checkoutStore } = useStores();

  const [loading, setLoading] = useState(false);
  const [canMakePayments, setCanMakePayments] = useState < boolean > (true);
  // const canMakePayments = useRef(false);
  const [sessionRequest, setSessionRequest] = useState < any > ({});
  // const [paymentsSession, setPaymentsSession] = useState(null);

  // 关闭loading
  const closeLoading = () => {
    setLoading(false);
    checkoutStore.setSafetyLoading(false);
  };

  // 关闭loading
  const onPayError = () => {
    UKToast.show({
      content: t("common.message.networkError"), // 弹窗内容
      icon: "error", // 可选：success, fail, loading, warn, info，影响图标
    });
    closeLoading();
  };

  /**
   *
   * 提单，并唤起支付
   *
   */
  const handleSubmit = async () => {
    setLoading(true);
    checkoutStore.setSafetyLoading(true);

    initPaymentsSession();
    // 提单接口在父组件中统一处理

    const res: any = await props.onSubmit();

    // 如果提单成功，则唤起支付
    if (res.success) {
      try {
        const payload = JSON.parse(res.data.payload);
        setSessionRequest(payload);

        //  用户发起支付请求后，调用你的服务器请求一个新的merchant session
        paymentsSession.onvalidatemerchant = async (event: any) => {

          let merchantSession = await validateAppleMerchant({
            validationUrl: event.validationURL,
            payMethod: String(PAY_TYPE.APPLE),
          });

          if (merchantSession) {
            try {
              paymentsSession.completeMerchantValidation(merchantSession);
            } catch (error) {
              paymentsSession.abort();
              onPayError();
              console.error("Error fetching merchant session", error);
            }
            return
          }
          paymentsSession.abort();
          onPayError();
        };
        /** 
         * 用户付款后，Apple Pay会调用此方法，以确认付款是否成功。
         * 
        */
        paymentsSession.onpaymentauthorized = (event) => {
          timer = setInterval(() => {
            count += 1;
            redirectResult(event.payment?.token || {});
            if (count === 4) {
              closePayInterval();
            }
          }, 5000);
        };

        /** Start session */
        paymentsSession.begin();

      } catch (error) {
        console.log(error, "error----");

        onPayError();
      }
      return;
    }

    closeLoading();
  };

  /**
   *
   * @param sessionResuest 支付初始化session请求参数
   */
  const initPaymentsSession = () => {
    // const session = new (window as any).ApplePaySession(3, sessionResuest);
    // setPaymentsSession(session);
    console.log("Apple pay session: ");

    try {
      const request = {
        countryCode: "GB",
        currencyCode: "GBP",
        supportedNetworks: ["visa", "masterCard", "amex", "discover"],
        merchantCapabilities: ["supports3DS"],
        total: { label: "JOYBUY", amount: (checkoutStore as any).orderPaymentPrice, type: "final" },
      };
      const session = new (window as any).ApplePaySession(3, request);
      /**
       * 支付取消
       *
       */
      session.oncancel = (err: any) => {
        console.log("Apple pay session canceled", err);
        closeLoading();
      };
      /**
       * 支付报错
       */

      session.onerror = (error: any) => {
        console.log("Apple pay session error: ", error);
        onPayError();
      };

      paymentsSession = session;

      console.log("Apple pay session: ", session);
    } catch (error) {
      console.log(error, "initPaymentsSession error----");
      onPayError();
    }
  };

  /** 获取支付结果失败 */
  const closePayInterval = () => {
    clearInterval(timer);
    closeLoading();
    paymentsSession.completePayment(ApplePaySession.STATUS_FAILURE);
  }


  // 后端redirect接口
  const redirectResult = async (paymentData: any) => {
    const requestData = {
      txnSeqno: (checkoutStore.payResult as any).id,
      txnScene: "Consumption",
      payMethod: Number(checkoutStore.payMethod),
      urlParams: {
        payDataExt: JSON.stringify(paymentData),
      },
    };

    const res = await redirectPayResult(requestData);
    const statusRes = res?.status;

    switch (statusRes) {
      case PAY_STATUS.ERROR:
        closePayInterval();
        break;
      case PAY_STATUS.SUCCESS:
        clearInterval(timer);
        closeLoading();
        paymentsSession.completePayment(ApplePaySession.STATUS_SUCCESS);
        props.onLoadingResult(requestData, onPayError)
        break;
      default:
        break;
    }
  };

  // 加载Apple pay sdk
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://applepay.cdn-apple.com/jsapi/1.latest/apple-pay-sdk.js";
    script.async = true;
    document.head.appendChild(script);

    // 检查是否可以支付
    isReadyToPay();

    return () => {
      paymentsSession = null;
      document.head.removeChild(script);
    };
  }, []);

  /**
   *
   * 检查是否可以支付
   * 不可以支付禁Apple pay按钮
   * */
  const isReadyToPay = async () => {
    // 检查 ApplePaySession 对象是否存在
    let canPay = false;
    if ("ApplePaySession" in window) {
      // 检测支付能力
      try {
        canPay = await (window as any).ApplePaySession.canMakePayments();
      } catch (error) {
        console.log("Apple pay isReadyToPay error: ", error);
      }
    }
    setCanMakePayments(canPay);
  };

  return (
    <>
      <Button
        fullWidth
        sx={{
          "&.Mui-disabled": {
            opacity: 0.3,
            "&:hover": {
              opacity: "0.3 !important",
              backgroundColor: "#1A1A1A !important",
            },
            "&:active": {
              opacity: "0.3 !important",
              backgroundColor: "#1A1A1A !important",
            },
          },
        }}
        className={Styles.commonAppleBtn}
        disabled={loading || checkoutStore.submitOrderBtnDisabled || !canMakePayments}
        onClick={handleSubmit}
      >
        <ApplePaySvg width={45} height={18} />
      </Button>
      <div id="applePayButton"></div>
    </>
  );
});

export default ApplePay;
